// upload.js
import AWS from 'aws-sdk';
import * as jQuery from 'jquery';
import { isEmpty } from 'lodash';

import config from './config';
import { getUser } from './user';
import { listObjectsV2, async_getSignedURL } from './files';
import { s3UserImages } from '../store/actions';
import { uploads as actions } from '../store/actions';

export const upload_steps = async (data, template_id, dispatch, user_id) => {
  dispatch(actions.reading());
  const file_data = await reader(data);
  const content_type = 'image/jpeg';
  dispatch(actions.signing());
  const signed_data = await sign();
  const upload_key = signed_data['key'];
  const upload_url = signed_data['url'];
  dispatch(actions.signed(upload_url, upload_key));
  dispatch(actions.uploading());
  await upload(upload_url, file_data, content_type);
  dispatch(actions.transforming());
  const transformed = await transform(template_id, upload_key, user_id);
  await preload(transformed['watermarked_url']);
  dispatch(actions.complete(transformed));
};

export const sign = () => {
  // It's a promise (?)
  return jQuery.ajax({
    url: `${config.APIRoot}images/sign`,
    method: 'GET'
  });
};

export const getImageForCrop = (file, dispatch) => {
  let reader = new FileReader();
  reader.onloadend = () => {
    dispatch(actions.read(reader.result));
  };
  reader.readAsDataURL(file);
};

export const reader = fileObj => {
  // It's a promise. If successful it returns the contents of the file
  const fileReader = new FileReader();
  return new Promise((resolve, reject) => {
    fileReader.onerror = () => {
      fileReader.abort();
      reject(console.log('failed to read file'));
    };
    fileReader.onload = () => {
      resolve(fileReader.result);
    };
    fileReader.readAsArrayBuffer(fileObj);
  });
};

export const upload = (url, data, content_type) => {
  // It's a promise (?), we don't care about the result, only success or failure
  return jQuery.ajax({
    url: url,
    method: 'PUT',
    contentType: content_type,
    data: data,
    processData: false
  });
};

export const transform = async (template_id, upload_id) => {
  // It's a promise. It returns the URL of the new image
  const user = await getUser();
  let body = {
    template_id: template_id,
    upload_id: upload_id
  };
  if (user !== null) body['user_id'] = AWS.config.credentials.identityId;
  const payload = JSON.stringify(body);
  const url = `${config.APIRoot}images/demo/transform`;
  return jQuery.ajax({
    url: url,
    method: 'POST',
    contenType: 'application/json',
    data: payload
  });
};

export const preload = url => {
  // It's a promise...
  let img = document.createElement('img');
  return new Promise((resolve, reject) => {
    img.onload = () => {
      resolve();
    };
    img.src = url;
  });
};

export const purchaseWithCredit = async (template_id, upload_id) => {
  // It's a promise. It returns the URL of the new image
  const user = await getUser();
  let body = {
    template_id: template_id,
    upload_id: upload_id
  };
  if (user === null) return 'user not logged in';
  body['identity_id'] = AWS.config.credentials.identityId;
  const payload = JSON.stringify(body);
  const url = `${config.APIRoot}/images/buy/use_credit`;
  return jQuery.ajax({
    url: url,
    method: 'POST',
    contenType: 'application/json',
    data: payload
  });
};

export const getDownload = async (template_id, upload_id) => {
  // It's a promise. It returns the URL of the new image
  const user = await getUser();
  let body = {
    template_id: template_id,
    upload_id: upload_id
  };
  if (user !== null) body['identity_id'] = AWS.config.credentials.identityId;
  const payload = JSON.stringify(body);
  const url = `${config.APIRoot}images/buy/confirm`;
  return jQuery.ajax({
    url: url,
    method: 'POST',
    contenType: 'application/json',
    data: payload
  });
};

export const getResizedLibraryImage = async (original_key, size, dispatch) => {
  dispatch(
    s3UserImages.downloadingAlternateSize(original_key, size.description)
  );
  const user = await getUser();
  const list_params = {
    Bucket: config.UserBucket,
    Prefix:
      original_key.substring(0, original_key.indexOf('fullsize')) +
      size.description
  };
  // Check if img already exists, then either download it or generate it
  const images = await listObjectsV2(list_params);
  if (!isEmpty(images.Contents)) {
    const signedUrlParams = existingImageSignedUrlParams(original_key, size);
    const url = await async_getSignedURL(signedUrlParams);
    return {
      download_url: url
    };
  } else {
    const [url, payload] = lambdaImageGenerationPayload(
      original_key,
      size,
      user
    );
    return jQuery.ajax({
      url: url,
      method: 'POST',
      contenType: 'application/json',
      data: payload
    });
  }
};

const existingImageSignedUrlParams = (original_key, size) => {
  const key = original_key.substring(0, original_key.indexOf('fullsize'));
  // We just want the uuid of the user image from the full s3 path
  const downloadPrefix = original_key.split('/').reverse()[1];
  return {
    Bucket: config.UserBucket,
    Key: key + size.description,
    Expires: 300,
    ResponseContentDisposition: `attachment;
      filename=${downloadPrefix}_${size.description}.jpg`
  };
};

const lambdaImageGenerationPayload = (original_key, size, user) => {
  // We just want the uuid of the user image from the full s3 path
  const imageUUID = original_key.split('/').reverse()[1];
  let body = {
    original_key: original_key,
    size: size,
    base_key: original_key.substring(0, original_key.indexOf('fullsize')),
    filename: `${imageUUID}_${size.description}`
  };
  if (user !== null) body['identity_id'] = AWS.config.credentials.identityId;
  const payload = JSON.stringify(body);
  const url = `${config.APIRoot}images/library/other_size`;
  return [url, payload];
};



// WEBPACK FOOTER //
// ./src/utils/upload.js